<template>
  <b-overlay
    :show="showLoader"
    rounded="sm"
  >
    <b-card
      v-if="data"
      no-body
      class="card-browser-states"
    >
      <b-card-header>
        <div>
          <b-card-title>Lista de recursos</b-card-title>
        </div>
        <b-card-text
          v-if="updatedAt !== ''"
          class="font-small-2 mr-25 mb-0"
        >
          Datos cargados <b>{{ updatedAt }}</b>
        </b-card-text>
      </b-card-header>

      <b-card-body>
        <div
          v-for="source in data"
          :key="source.id"
          class="browser-states mt-1"
        >
          <b-media no-body>
            <!-- Editar -->
            <b-avatar
              v-b-tooltip.hover="(source.available && !isSelectedSource(source)) ? 'Editar recurso' : (isSelectedSource(source)) ? 'Este recurso está siendo editado' : 'No disponible'"
              :badge="isSelectedSource(source)"
              :badge-top="isSelectedSource(source)"
              badge-offset="-0.5em"
              rounded
              variant="light-secondary"
              size="30px"
            >
              <b-img
                :src="require('@/assets/images/icons/brush.svg')"
                :style="source.available ? '' : 'filter: grayscale(100%); opacity: 50%;'"
                :class="source.available ? 'cursor-pointer' : 'cursor-default'"
                alt="browser img"
                height="22"
                @click="(source.available) ? willEdit(source) : notAvailable()"
              />
            </b-avatar>

            <!-- Eliminar -->
            <b-avatar
              v-b-tooltip.hover="source.available ? 'Borrar recurso' : 'No disponible'"
              rounded
              variant="light-secondary"
              class="mx-50"
              size="30px"
            >
              <feather-icon
                icon="TrashIcon"
                size="18"
                :class="source.available ? 'text-danger cursor-pointer' : 'text-secondary cursor-default'"
                @click="(source.available) ? confirmDelete(source) : notAvailable()"
              />
            </b-avatar>

            <!-- Nombre del recurso -->
            <h6 class="align-self-center my-auto">
              {{ source.nombre }}
            </h6>
          </b-media>
          <!-- Disponibilidad para edición/borrado -->
          <div class="d-flex align-items-center">
            <span class="font-weight-bold text-body-heading mr-1">
              <b-badge
                :variant="source.available ? 'success' : 'danger'"
                class="badge-glow"
              >
                {{ source.available ? 'Disponible para modificar' : 'Bloqueado' }}
              </b-badge>
            </span>
          </div>
        </div>
      </b-card-body>

    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BImg,
  BAvatar,
  BBadge,
  BMedia,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardText,
  BOverlay,
  VBTooltip,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { formhttp } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { saveChanges } from './useRecursos'

export default {
  components: {
    BCard,
    BImg,
    BAvatar,
    BBadge,
    BMedia,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardText,
    BOverlay,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    sourceSelected: {
      type: Object,
      default: () => {},
    },
    updatedAt: {
      type: String,
      default: '',
    },
  },
  methods: {
    confirmDelete(recurso) {
      this.$swal({
        title: '¿Está seguro de eliminar?',
        html: `Si continúa se eliminará el recurso: <b>"${recurso.nombre}"</b>. Esta acción es irreversible.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.willDelete(recurso.id)
        }
      })
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const showLoader = ref(false)

    //* Recurso bloqueado
    const notAvailable = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Recurso bloqueado',
          text: 'Este recurso se encuentra bloqueado para su edición/borrado, esto debido a que ya se encuentra asignado a un curso.',
          icon: 'AlertCircleIcon',
          variant: 'warning',
        },
      },
      { timeout: 10000 })
    }

    const isSelectedSource = source => source.id === props.sourceSelected.id

    //* Confirm if you want to edit the source
    const willEdit = selected => {
      emit('sourceSelected', selected)
    }

    //* Delete resource
    const willDelete = x => {
      showLoader.value = true
      saveChanges({ action: 4, x })
        .then(response => {
          const { icon, label } = formhttp(response.status)
          showLoader.value = false

          if (response.status === 200) emit('updateData')

          toast({
            component: ToastificationContent,
            props: {
              title: 'Resultado de petición',
              text: response.message,
              icon,
              variant: label,
            },
          },
          { timeout: 8000 })
        }, error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en borrando recurso',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    return {
      // methods
      notAvailable,
      willDelete,
      // willDelete,
      willEdit,
      isSelectedSource,
      // Loader
      showLoader,
    }
  },
}
</script>
